import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

export default class extends Controller {
  static values = {
    enableTime: { type: Boolean, default: false },
    altFormat: { type: String, default: 'M j, Y' },
    dateFormat: { type: String, default: 'Y-m-d' }
  }

  connect() {
    this.picker = flatpickr(this.element, {
      enableTime: this.enableTimeValue,
      dateFormat: this.dateFormatValue,
      altInput: true,
      altFormat: this.altFormatValue,
      allowInput: true
    })
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
    }
  }
}
